import * as urlUtils from 'utils/Url';

export function getPathAlertRecipientsGroups(qs={}) {
  return urlUtils.appendQueryString(`/alert-recipients-groups`, qs);
}

export function getPathUsageAlerts(qs={}) {
  return `/usage-alerts`;
}

export function getPathEditUsageAlerts() {
  return `/usage-alerts/edit`;
}
